module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-container"
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "width": "100vw",
      "z-index": "99"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": "primary",
      "dark": "",
      "fixed": ""
    }
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', {
    staticStyle: {
      "font-family": "'DINPro Regular'"
    }
  }, [_vm._v(_vm._s(_vm.$router.history.current.path.split('/')[2]))]), _vm._v(" "), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticStyle: {
      "z-index": "99999"
    },
    attrs: {
      "mini-variant": _vm.mini,
      "absolute": "",
      "dark": "",
      "temporary": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    staticClass: "pa-1"
  }, [(!_vm.mini) ? _c('v-list-tile', {
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "font-family": "'DINPro Bold",
      "letter-spacing": "0.2rem'"
    }
  }, [_vm._v("Navigation")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
    attrs: {
      "light": ""
    }
  }), _vm._v(" "), _c('v-list-tile', {
    staticClass: "nav-tile",
    attrs: {
      "avatar": "",
      "tag": "div"
    },
    on: {
      "click": function($event) {
        return _vm.routeTo('catagory')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "font-family": "'DINPro Light'"
    }
  }, [_vm._v("Categories")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "nav-tile",
    attrs: {
      "avatar": "",
      "tag": "div"
    },
    on: {
      "click": function($event) {
        return _vm.routeTo('jewelry')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "font-family": "'DINPro Light'"
    }
  }, [_vm._v("Jewelry")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "light": ""
    }
  })], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aef9942c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cms/CmsContainer.vue
// module id = 222
// module chunks = 1